<template>
    <div class="header-container">
        <div class="app-header">
            <div class="left">
                <img class="logo" src="../../../assets/img/deloitte-white.svg" alt="">
                <div class="line"></div>
                <div class="sub-text-wrapper">
                  <div class="sub-logo">{{ $t('header_text1') }}</div>
                  <div class="sub-info">{{ $t('header_text2') }}</div>
                </div>
            </div>
            <div class="right">
              <div>
                <el-dropdown @command="dropdownHandleClick">
                  <div class="el-dropdown-link flex-wrap flex-between">
                    <div>
                      <div class="name">{{ userInfo.nickName }}</div>
                      <div class="deptName">{{ roleName }}</div>
                    </div>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="changePassword">{{ $t('header_text3') }}</el-dropdown-item>
                    <el-dropdown-item
                        v-if="isMobile"
                        divided
                        command="lang-en-US"
                        :class="{ 'is-lang-active': languageActiveIndex === 'en-US' }">
                      En
                    </el-dropdown-item>
                    <el-dropdown-item
                        v-if="isMobile"
                        command="lang-zh-TW"
                        :class="{ 'is-lang-active': languageActiveIndex === 'zh-TW' }">
                      繁體
                    </el-dropdown-item>
                    <el-dropdown-item
                        v-if="isMobile"
                        command="lang-zh-CN"
                        :class="{ 'is-lang-active': languageActiveIndex === 'zh-CN' }">
                      简体
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="line desktop-only-line"></div>
              <el-menu v-if="!isMobile"
                       :default-active="languageActiveIndex"
                       class="el-menu-demo header-language-menu"
                       mode="horizontal"
                       @select="handleSelectLanguage">
                <el-submenu index="1">
                  <template slot="title">
                    <span v-if="languageActiveIndex === 'en-US'">En</span>
                    <span v-if="languageActiveIndex === 'zh-TW'">繁體</span>
                    <span v-if="languageActiveIndex === 'zh-CN'">简体</span>
                  </template>
                  <el-menu-item index="en-US">En</el-menu-item>
                  <el-menu-item index="zh-TW">繁體</el-menu-item>
                  <el-menu-item index="zh-CN">简体</el-menu-item>
                </el-submenu>
              </el-menu>
              <div class="line"></div>
              <el-link style="color: #fff;" :underline="false" icon="el-icon-switch-button" @click="handleClickLogout"></el-link>

            </div>
        </div>
        <div class="sub-header-wrapper">
          <div class="sub-header">
            <div class="sub-header-nav">
              <div
                  v-if="getRoleShow('Home')"
                  :class="{'nav-item': true, 'active': $route.path==='/clientAdmin/home' || $route.path==='/clientAdmin/engagementInfo'}"
                  @click="goto('/clientAdmin/home')"
              >{{ $t('menu3') }}
              </div>
              <div
                  v-if="getRoleShow('Engagement Detail')"
                  :class="{'nav-item': true, 'active': $route.path==='/clientPage/engagement'}"
                  @click="goto('/clientPage/engagement')"
              >{{ $t('menu1') }}
              </div>
              <div
                  v-if="getRoleShow('Board Evaluation') && $route.path !== '/clientPage/engagement'"
                  :class="{'nav-item': true, 'active':  $route.path==='/clientPage/engagementDetail' || $route.path==='/clientPage/detail'}"
              >{{ $t('menu2') }}
              </div>

              <div
                  v-if="getRoleShow('Engagement Management')"
                  :class="{'nav-item': true, 'active': $route.path==='/companyList' || $route.path==='/engagementManagementList'}"
                  @click="goto('/companyList')"
              >{{ $t('menu4') }}
              </div>
              <div
                  v-if="getRoleShow('Package Management')"
                  :class="{'nav-item': true, 'active': $route.path==='/packageList' || $route.path==='/subModule' || ($route.path==='/subQuestion' && $route.query.fromPage === 'package')}"
                  @click="goto('/packageList')"
              >{{ $t('menu5') }}
              </div>
              <div
                  v-if="getRoleShow('Module Management')"
                  :class="{'nav-item': true, 'active': $route.path==='/moduleList' || ($route.path==='/subQuestion' && $route.query.fromPage === 'module')}"
                  @click="goto('/moduleList')"
              >{{ $t('menu6') }}
              </div>
              <div
                  v-if="getRoleShow('Question Management')"
                  :class="{'nav-item': true, 'active': $route.path==='/questionList'}"
                  @click="goto('/questionList')"
              >{{ $t('menu7') }}
              </div>
              <div
                  v-if="getRoleShow('Security & Access')"
                  :class="{'nav-item': true, 'active': $route.path==='/securityAccess'}"
                  @click="goto('/securityAccess')"
              >{{ $t('menu8') }}
              </div>
              <div
                  v-if="getRoleShow('AI Agent')"
                  :class="{'nav-item': true, 'active': $route.path==='/aiChat'}"
                  @click="goto('/aiChat')"
              >{{ $t('menu10') }}
              </div>
              <div
                  v-if="getRoleShow('System Management')"
                  :class="{'nav-item': true, 'active': $route.path==='/systemManagement'}"
                  @click="goto('/systemManagement')"
              >{{ $t('menu9') }}
              </div>
            </div>

            <div v-if="showCompanySwitcher" class="company-switcher">
              <span class="company-switcher-label">{{ $t('header_text6') }}</span>
              <el-select
                  v-model="selectedCompanyId"
                  size="mini"
                  :placeholder="$t('header_text7')"
                  @change="handleCompanySwitch"
              >
                <el-option
                    v-for="item in companyRoleOptions"
                    :key="item.companyId + '-' + item.roleId"
                    :label="getCompanyOptionLabel(item)"
                    :value="item.companyId"
                />
              </el-select>
            </div>
          </div>
        </div>
      <el-dialog
          :title="$t('header_text3')"
          :visible.sync="changePasswordDialogVisible"
          width="30%"
          :before-close="handleClose">
        <div>
          <el-form :model="ruleForm"
                   :rules="rules"
                   :inline="true"
                   ref="ruleForm"
                   label-position="top"
                   label-width="80px"
                   class="ms-content">
            <el-form-item prop="oldPassword" :label="$t('header_text4')">
              <el-input v-model="ruleForm.oldPassword" placeholder="">
              </el-input>
            </el-form-item>
            <el-form-item prop="newPassword" :label="$t('header_text5')">
              <el-input v-model="ruleForm.newPassword" placeholder="">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="changePasswordDialogVisible = false">{{ $t('cancel') }}</el-button>
          <el-button type="primary" @click="passwordSubmit">{{ $t('confirm') }}</el-button>
        </div>
      </el-dialog>
    </div>

</template>

<script>
import {getUserInfo, setUserInfo} from "../../../utils/auth";
import {updatePwd, getUserInfo as fetchUserInfo} from "@/api/login";
import OpenCC from 'opencc-js';
const converter = OpenCC.Converter({ from: 'cn', to: 'tw' });
const CLIENT_ADMIN_ROLE_KEYS = ['ca', 'da'];

export default {
    name: "AppHeader",
    data() {
      return {
        roleName: '',
        languageActiveIndex: 'en-US',
        isMobile: false,
        changePasswordDialogVisible: false,
        selectedCompanyId: '',
        companyRoleOptionsFromProfile: null,
        ruleForm: {
          oldPassword: '',
          newPassword: '',
        },
        rules: {
          oldPassword: {required: true, message: this.$t('login_text29'), trigger: 'blur'},
          newPassword: {required: true, message: this.$t('login_text30'), trigger: 'blur'},
        },
      }
    },
    computed: {
        userInfo() {
          return getUserInfo() || {};
        },
      companyRoleOptions() {
        if (this.companyRoleOptionsFromProfile && this.companyRoleOptionsFromProfile.length) {
          return this.companyRoleOptionsFromProfile;
        }
        return this.buildCompanyRoleOptions(getUserInfo() || {});
      },
      showCompanySwitcher() {
        const path = this.$route && this.$route.path ? this.$route.path : '';
        const onClientAdmin = path.indexOf('/clientAdmin') === 0 || path.indexOf('/securityAccess') === 0;
        return onClientAdmin && this.companyRoleOptions.length > 1;
      },
      //不同权限看到的菜单不一样
      getRoleShow() {
        return function (page) {
          let _result = false;
          const activeRole = getUserInfo() && getUserInfo().roles && getUserInfo().roles[0];
          if (!activeRole) {
            return false;
          }
          const _role = activeRole.roleKey;
          // Super Admin is roleId=1 (see role.service getPermissionsByRoleIds).
          // Platform Admin may also use roleKey "admin" but is not roleId 1.
          const isSuperAdmin = String(activeRole.roleId) === '1';

          if (page === 'System Management') {
            return isSuperAdmin;
          }

          if (_role === 'admin' || isSuperAdmin) {
            if (page === 'Engagement Management' || page === 'Package Management' || page === 'Module Management' || page === 'Question Management' || page === 'Security & Access' || page === 'AI Agent') {
              _result = true
            }
          } else if (_role === 'pa') {
            if (page === 'Engagement Management' || page === 'Package Management' || page === 'Module Management' || page === 'Question Management' || page === 'Security & Access' || page === 'AI Agent') {
              _result = true
            }
          } else if (_role === 'da') {
            if (page === 'Engagement Management' || page === 'Security & Access') {
              _result = true
            }
          } else if (_role === 'ca') {
            if (page === 'Home' || page === 'Security & Access' ) {
              _result = true
            }
          } else if (_role === 'participant') {
            if (page === 'Board Evaluation' || page === 'Engagement Detail') {
              _result = true
            }
          }
          return _result;
        };

      },
    },
    methods: {
      buildCompanyRoleOptions(userInfo) {
        const roles = (userInfo && (userInfo.originalRoles || userInfo.roles)) || [];
        const companyMap = new Map();
        roles.forEach((role) => {
          if (!role || !role.companyId || !CLIENT_ADMIN_ROLE_KEYS.includes(role.roleKey)) {
            return;
          }
          const companyId = String(role.companyId);
          if (!companyMap.has(companyId)) {
            companyMap.set(companyId, {
              ...role,
              companyId,
            });
          }
        });
        return Array.from(companyMap.values());
      },
      async ensureOriginalRoles() {
        const userInfo = getUserInfo();
        if (!userInfo || !userInfo.roles || !userInfo.roles[0]) {
          return;
        }
        if (!CLIENT_ADMIN_ROLE_KEYS.includes(userInfo.roles[0].roleKey)) {
          return;
        }
        try {
          const res = await fetchUserInfo();
          const allRoles = (res.data && res.data.roles) || [];
          const activeCompanyId = userInfo.roles[0].companyId;
          const selectedRole = allRoles.find(
            (role) => role
              && String(role.companyId) === String(activeCompanyId)
              && CLIENT_ADMIN_ROLE_KEYS.includes(role.roleKey)
          ) || userInfo.roles[0];
          const nextUserInfo = {
            ...userInfo,
            ...res.data,
            originalRoles: allRoles,
            roles: [selectedRole],
          };
          setUserInfo(nextUserInfo);
          this.companyRoleOptionsFromProfile = this.buildCompanyRoleOptions(nextUserInfo);
          this.syncSelectedCompanyId();
          this.refreshRoleName(nextUserInfo);
        } catch (e) {
          this.companyRoleOptionsFromProfile = this.buildCompanyRoleOptions(userInfo);
          console.log(e);
        }
      },
      syncSelectedCompanyId() {
        const userInfo = getUserInfo() || {};
        const activeCompanyId = userInfo.roles && userInfo.roles[0] && userInfo.roles[0].companyId;
        this.selectedCompanyId = activeCompanyId == null ? '' : String(activeCompanyId);
      },
      getCompanyOptionLabel(item) {
        if (item && item.companyInfo && item.companyInfo.entityName) {
          return item.companyInfo.entityName;
        }
        return item && item.companyId ? String(item.companyId) : '';
      },
      handleCompanySwitch(companyId) {
        const normalizedCompanyId = companyId == null ? '' : String(companyId);
        const userInfo = getUserInfo();
        if (!userInfo) {
          return;
        }

        const allRoles = userInfo.originalRoles || userInfo.roles || [];
        const selectedRole = allRoles.find(
          (role) => role
            && String(role.companyId) === normalizedCompanyId
            && CLIENT_ADMIN_ROLE_KEYS.includes(role.roleKey)
        ) || this.companyRoleOptions.find(
          (role) => String(role.companyId) === normalizedCompanyId
        );

        if (!selectedRole) {
          return;
        }

        const nextUserInfo = {
          ...userInfo,
          originalRoles: userInfo.originalRoles || allRoles,
          roles: [selectedRole],
        };
        setUserInfo(nextUserInfo);
        this.selectedCompanyId = normalizedCompanyId;
        this.refreshRoleName(nextUserInfo);

        if (this.$route.path !== '/clientAdmin/home') {
          this.$router.push({ path: '/clientAdmin/home' }).then(() => {
            location.reload();
          }).catch(() => {
            location.reload();
          });
        } else {
          location.reload();
        }
      },
      refreshRoleName(userInfo) {
        const role = userInfo && userInfo.roles && userInfo.roles[0];
        if (!role) {
          this.roleName = '';
          return;
        }
        if (this.$i18n.locale === 'en-US') {
          this.roleName = role.roleNameEn;
        } else if (this.$i18n.locale === 'zh-TW') {
          this.roleName = converter(role.roleName);
        } else {
          this.roleName = role.roleName;
        }
      },
      handleSelectLanguage(language){
        console.log(language)
        this.languageActiveIndex = language;
        localStorage.setItem('bdLanguageChoose', language);
        this.$i18n.locale = language;
        location.reload();
      },
      passwordSubmit() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            this.updatePwdFn();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      closePasswordDialog() {
        this.$refs['ruleForm'].clearValidate();
        this.changePasswordDialogVisible = false;
      },
      dropdownHandleClick(command) {
        console.log(command)
        if(command === 'changePassword') {
          this.changePasswordDialogVisible = true;
        } else if (command && String(command).indexOf('lang-') === 0) {
          this.handleSelectLanguage(String(command).replace('lang-', ''));
        }
      },
      updateIsMobile() {
        this.isMobile = window.innerWidth <= 768;
      },
      handleClose() {
        this.changePasswordDialogVisible = false;
      },

        goto(path) {
          if(this.$route.path !== path) {
            this.$router.push({
              path: path,
            });
          }
        },
      handleClickLogout() {
        let _self = this;
        _self.$confirm(`<p class="msgbox-body-text">${this.$t('login_text26')}</p>`, {
          dangerouslyUseHTMLString: true,
          customClass: 'tone-vehicle',
          confirmButtonText: _self.$t('confirm'),
          cancelButtonText: _self.$t('cancel'),
        }).then(action => {
          _self.logoutFn();
        }).catch(action => {});
      },
      async updatePwdFn() {
        try {
          let res = await updatePwd({
            oldPassword: this.ruleForm.oldPassword,
            newPassword: this.ruleForm.newPassword,
          });
          console.log(123,res.data)
          if (res.data.code !== 200){
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
          this.closePasswordDialog();
        } catch (e) {
          console.log(e)
        }
      },
      async logoutFn() {
        let _role = getUserInfo().roles[0].roleKey;
        this.$store.dispatch("FedLogOut").then(() => {
          //注销后再访问入口页面时，只显示空白页，未显示「拒绝存取（denied）」的讯息，亦未自动跳转回登入页(解决此问题)
          this.$modal.msgSuccess(this.$t('login_text33'));
          localStorage.setItem('lastRole', _role);
          if (_role === 'admin' || _role === 'pa' || _role === 'da') {
            this.goto('/admin');
          } else if (_role === 'ca') {
            this.goto('/client');
          } else if (_role === 'participant') {
            this.goto('/');
          }
        });
      },
    },
  created() {
      if(localStorage.getItem('bdLanguageChoose')) {
        this.languageActiveIndex = localStorage.getItem('bdLanguageChoose');
      }else {
        this.languageActiveIndex = 'en-US';
      }
      let userInfo = getUserInfo();
      this.$i18n.locale = this.languageActiveIndex;
      this.refreshRoleName(userInfo);
      this.syncSelectedCompanyId();
  },
  watch: {
    '$route.path'() {
      this.syncSelectedCompanyId();
    },
  },
  mounted() {
    this.updateIsMobile();
    window.addEventListener('resize', this.updateIsMobile);
    this.ensureOriginalRoles();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
}
</script>

<style scoped lang="less">
.header-container {
  width: 100%;
  background-color: #000;
}
.app-header {
    max-width: 90%;
    padding-right: 25px;
    margin: 0 auto;
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
        color: #000;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .logo {
            width: 128px;
        }

        .line {
            height: 20px;
            width: 1px;
            background-color: #fff;
            margin: 0 30px;
        }
        .sub-text-wrapper {
          .sub-logo {
            color: #86BC25;
            font-style: italic;
            font-weight: 700;
            font-size: 20px;
          }
          .sub-info {
            color: #CCC;
            font-size: 14px;
          }
        }


    }

    .right {
        color: #fff;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      .name {
        padding-right: 10px;
        font-size: 14px;
        font-weight: 700;
        color: #fff;
      }
      .deptName {
        color: #9ca3af; /* light gray */
        font-weight: 400;
        font-size: 12px;
      }
      .line {
        height: 14px;
        width: 1px;
        background-color: #fff;
        margin: 0 10px;
      }
      /deep/.el-submenu__title {
        padding: 0 10px;
      }
      .logout {
        cursor: pointer;
      }
    }
}

.sub-header-wrapper {
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);

  .sub-header {
    max-width: 90%;
    height: 45px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .sub-header-nav {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      min-width: 0;
      overflow-x: auto;
    }

    .company-switcher {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      margin-left: 16px;

      .company-switcher-label {
        margin-right: 8px;
        font-size: 0.85rem;
        color: #6b7280;
        white-space: nowrap;
      }

      /deep/ .el-select {
        width: 220px;
      }
    }

    .nav-item {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      padding: 0 4px;
      margin-right: 20px;
      cursor: pointer;
      font-size: 0.9rem;
      color: #374151;
      transition: color 0.2s ease;

      &:hover {
        color: #111827;
      }

      &.active {
        position: relative;
        color: #86BC25;
        font-weight: bold;
      }
      &.active::after {
        position: absolute;
        left: -8px;
        right: -8px;
        bottom: 0;
        content: "";
        height: 4px;
        background-color: #86BC25;
      }
    }
  }
}

/deep/ .help-dropdown-item {
    font-weight: bold;
}
.help-icon {
    cursor: pointer;
}
/deep/.el-menu.el-menu-demo {
  background-color: #000;
  border: 0;
}
/deep/.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  background-color: #000;
}
/deep/.el-menu--horizontal.el-menu-demo>.el-submenu.is-active .el-submenu__title {
  border: 0;
}
/deep/.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  color: #fff;
}

@media (max-width: 768px) {
  .app-header {
    max-width: 100%;
    height: auto;
    min-height: 56px;
    padding: 8px 12px;
    box-sizing: border-box;
    .left {
      .logo {
        width: 88px;
      }
      .line {
        margin: 0 10px;
      }
      .sub-text-wrapper {
        .sub-logo {
          font-size: 16px;
        }
        .sub-info {
          display: none;
        }
      }
    }
    .right {
      .name {
        max-width: 72px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .deptName {
        max-width: 72px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .line {
        margin: 0 6px;
      }
      .desktop-only-line {
        display: none;
      }
    }
  }

  /deep/ .el-dropdown-menu__item.is-lang-active {
    color: #86BC25;
    font-weight: 700;
  }

  .sub-header-wrapper {
    .sub-header {
      max-width: 100%;
      padding: 0 12px;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;

      .company-switcher {
        margin-left: 12px;

        /deep/ .el-select {
          width: 160px;
        }
      }

      .nav-item {
        flex-shrink: 0;
        margin-right: 14px;
        font-size: 0.85rem;
        white-space: nowrap;
      }
    }
  }
}
</style>
